'use strict';

const emptyFunc = () => {};

export { emptyFunc };



// WEBPACK FOOTER //
// ./src/reactis/reactis-tabs/src/utils.js